export default __webpack_public_path__ + "static/media/tapicerowane1.2e595e58.jpg";